import { ReactElement } from 'react'
import { Heading } from '../atoms/Heading'

export function Hero({
	title,
	description,
	cta,
}: {
	title: string
	description?: string
	cta?: ReactElement[]
}) {
	return (
		<div className="relative container-auto flex items-center text-background max-h-[1000px] min-h-[600px]">
			<div className="flex flex-col items-center md:items-start pb-16 w-full lg:w-4/5">
				<Heading as="h1" className="text-4xl mb-8">
					<span
						dangerouslySetInnerHTML={{ __html: title }}
						className="text-center md:text-start text-2xl xl:text-4xl markdown"
					/>
				</Heading>
				{description && (
					<p className="max-w-[600px] text-lg text-center md:text-start mb-14">
						{description}
					</p>
				)}
				{cta && cta.map((c) => c)}
			</div>
		</div>
	)
}
